import state from './moduleAboutState.js'
import mutations from './moduleAboutMutations.js'
import actions from './moduleAboutActions.js'
import getters from './moduleAboutGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
